import { render, staticRenderFns } from "./CustomerFieldForm.vue?vue&type=template&id=7d76463c"
import script from "./CustomerFieldForm.vue?vue&type=script&lang=js"
export * from "./CustomerFieldForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports